import React, { useState } from 'react'
import { Menu, X } from 'lucide-react'
import { useNavigate } from 'react-router-dom'

interface NavigationProps {
  isSticky: boolean
}

const Navigation = ({ isSticky }: NavigationProps) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)
  const navigate = useNavigate()

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId)
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' })
    }
    setIsMobileMenuOpen(false)
  }

  const handleStartTrial = () => {
    navigate('/signup')
  }

  const handleSignIn = () => {
    window.location.href = 'https://flowbeatiq.com/dashboard/'
  }

  return (
    <nav className={`bg-white border-b border-gray-200 sticky top-0 z-50 transition-all duration-300 ${isSticky ? 'shadow-md' : ''}`}>
      <div className="container-padding">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center gap-2">
            <img src="/FlowBeatIQ-header.png" alt="FlowBeatIQ" className="h-12" />
          </div>
          
          <div className="hidden md:flex items-center gap-8">
            <button 
              onClick={() => scrollToSection('features')} 
              className="text-gray-600 hover:text-gray-900 transition-colors"
            >
              Features
            </button>
            <button 
              onClick={() => scrollToSection('pricing')} 
              className="text-gray-600 hover:text-gray-900 transition-colors"
            >
              Pricing
            </button>
            <button 
              onClick={() => scrollToSection('faq')} 
              className="text-gray-600 hover:text-gray-900 transition-colors"
            >
              FAQ
            </button>
            <button 
              onClick={handleSignIn}
              className="text-gray-600 hover:text-blue-600 transition-colors font-medium"
            >
              Sign In
            </button>
            <button 
              onClick={handleStartTrial}
              className="btn-primary"
            >
              Start Your Trial
            </button>
          </div>

          <div className="md:hidden">
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="text-gray-600 hover:text-gray-900"
            >
              {isMobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>
        </div>

        {isMobileMenuOpen && (
          <div className="md:hidden border-t border-gray-200 py-4">
            <div className="flex flex-col gap-4">
              <button 
                onClick={() => scrollToSection('features')} 
                className="text-left text-gray-600 hover:text-gray-900 transition-colors"
              >
                Features
              </button>
              <button 
                onClick={() => scrollToSection('pricing')} 
                className="text-left text-gray-600 hover:text-gray-900 transition-colors"
              >
                Pricing
              </button>
              <button 
                onClick={() => scrollToSection('faq')} 
                className="text-left text-gray-600 hover:text-gray-900 transition-colors"
              >
                FAQ
              </button>
              <button 
                onClick={handleSignIn}
                className="text-left text-gray-600 hover:text-blue-600 transition-colors font-medium"
              >
                Sign In
              </button>
              <button 
                onClick={handleStartTrial}
                className="btn-primary w-full text-center"
              >
                Start Your Trial
              </button>
            </div>
          </div>
        )}
      </div>
    </nav>
  )
}

export default Navigation
